import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'

import customerEmissionRequestReducer from './customerEmissionRequests/customerEmissionRequestSlice'
import emissionDataFormReducer from './emissionsDataForm/emissionDataFormSlice'

const createStore = () => {
	return configureStore({
		reducer: {
			customerEmissionRequest: customerEmissionRequestReducer,
			emissionDataForm: emissionDataFormReducer,
		},
	})
}
const store = createStore()

export default store

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>
